import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import styled from "styled-components";
import CountUp from "react-countup";
import Clock from "react-live-clock";
import { Message, MessageBox } from "element-react";
import ProgressBar from "react-bootstrap/ProgressBar";

import MS from "../../../commons/services/Moment";
import AS from "../../Login/Service/Authentication";
import CS from "../../../commons/services/Common";
import PS from "../MonitoringApiService";

import PageTitle from "../../../commons/components/PageTitle";
import {
  InfoArea,
  InfoHead,
  InfoContent,
  InfoList,
  ListWrapper,
  InfoListBox,
  CurrentTime,
} from "../PlantListStyle";
import LineChart from "../../../commons/components/LineChart";
import BarChart from "../../../commons/components/BarChart";
// import AllPowerControll from "./modulePowerControl/AllPowerControl";
import SolarInfo from "../../../commons/components/infoCard/SolarInfo";
import Divider from "../../../commons/components/divider/Divider";
import SolarBasicInfo from "../../../commons/components/infoCard/SolarBasicInfo";
import CountDownTimer from "../../../commons/components/CountDownTimer/CountDownTimer";
import { ROUTES } from "../../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";
import AutoFitText from "../../../commons/components/text/AutoFitText";

class SolarPanelDetail extends Component {
  constructor(props) {
    super(props);

    const projectIdByParam = props.match.params.projectId;
    const projectId = props.location.state?.projectId || projectIdByParam;
    this.state = {
      plantId: window.location.pathname.split("/").pop(),
      projectId,
      plantInfo: [],
      cst: {}, // 시공사
      // refreshSeconds: 90,
      // refreshStandard: 100 / 90,
      inverterSerialNos: [],
      combinerSerialNos: [],
      currentHourPower: 0,
      // currentHour: 0,

      todayPower: 0,
      todayProfit: 0,
      lastMonthPowerTime: 0,
      lastMonthPower: 0,
      lastMonthProfit: 0,
      thisMonthPowerTime: 0,
      thisMonthPower: 0,
      thisMonthProfit: 0,
      thisYearPowerTime: 0,
      thisYearPower: 0,
      thisYearProfit: 0,
      accumulationPowerTime: 0,
      accumulationPower: 0,
      accumulationProfit: 0,

      chartData: [],
      ymChartData: [],
      quarterChartData: [],
      yChartData: [],
      chartTodayHourlyData: [],
      info: {},

      isModalShow: false,
      isDisabled: "disabled",
      isDailyDisabled: "disabled",
      isCumulativeDisabled: "",
      dailyYear: MS.format(new Date(), "YYYY"),
      dailyMonth: MS.format(new Date(), "MM"),
      dailyDay: MS.format(new Date(), "DD"),

      year: MS.format(new Date(), "YYYY"),
      month: MS.format(new Date(), "MM"),

      cumulativeFromYear: Number(MS.format(new Date(), "YYYY")) - 1,
      cumulativeToYear: Number(MS.format(new Date(), "YYYY")),
      activeTab: "ym",

      todayPowerTime: 0,
      dayPower: 0,
      monthPower: 0,
      totalPower: 0,

      powerValue: false,
    };

    // this.timer = 0;
    this.handleModal = this.handleModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    // this.checkUserApprove();
    this.getProjectInfo();
    this.getPlantInfo();
  }
  componentDidUpdate() {
  }

  async getCstInfo() {
    const plantInfo = this.props.plantInfo;
    const res = await axios.get(`/cst/api/constructor/${plantInfo.constructorId}`);
    
    this.setState({
      cst: res.data,
      plantInfo: plantInfo,
    });
  }

  // componentWillUnmount() {
  //   clearInterval(this.timer);
  // }

  // startTimer = () => {
  //   if (this.timer == 0 && this.state.refreshSeconds > 0) {
  //     this.timer = setInterval(this.countDown, 1000);
  //   }
  // };

  // countDown = () => {
  //   const seconds = this.state.refreshSeconds - 1;
  //   this.setState({
  //     refreshSeconds: seconds,
  //   });
  //   if (seconds == 0) this.getData();
  // };

  async getProjectInfo() {
    const result = await axios.get(
      `/cst/api/project/id/` + this.state.projectId
    );
    this.setState({
      projectName: result.data.name,
      projectAddr: result.data.address,
    });
  }

  async getPlantInfo() {
    const { plantId, inverterSerialNos } = this.state;
    if (inverterSerialNos.length == 0) {
      const res = await axios.get(
        `/usr/api/user-plant/info?plantIds=${this.state.plantId}`
      );
      const inverterRes = await axios.get(
        `/cst/api/constructor-plant/equipment/${this.state.plantId}`
      )
      this.setState({
        info: res.data[0],
      });
      const plantInfos = AS.getLoggedInPlantInfos();
      let filteredPlantInfo = plantInfos.filter((v) => v.id == plantId);
      let inverterSerialNos = [];
      let combinerSerialNos = [];
      if (filteredPlantInfo[0]) {
        inverterSerialNos = CS.getKeyValues(
          filteredPlantInfo[0].invs,
          "serialNo"
        );
        combinerSerialNos = CS.getKeyValues(
          filteredPlantInfo[0].invs,
          "combinerSerialNo"
        );
      }
      
      if (inverterSerialNos.length == 0) {
        inverterSerialNos = CS.getKeyValues(inverterRes.data, "inverterNo");
      }
      const cstRes = await axios.get(`/cst/api/constructor/${res.data[0].constructorId}`);


      this.setState({
        inverterSerialNos: inverterSerialNos,
        combinerSerialNos: combinerSerialNos,
        plantInfo: filteredPlantInfo,
        cst: cstRes.data,
      });
    }

    this.getData();
    // const currentHour = Number(MS.format(new Date(), "HH"));
    // if (currentHour >= 7 && currentHour <= 18) {
    //   this.startTimer();
    // } else {
    //   clearInterval(this.timer);
    // }
    // this.setState({
    //   currentHour: currentHour,
    // });
  }

  getData = async () => {
    const {
      plantInfo,
      inverterSerialNos,
      cumulativeToYear,
      activeTab,
      dailyDay,
      dailyMonth,
      dailyYear,
      year,
      month,
    } = this.state; 
    const currentHourPowerList = await PS.getAccumulationPowerList({
      inverterSerialNos: inverterSerialNos,
      fromDate: MS.format(new Date(), "YYYY-MM-DD HH:00:00"),
      toDate: MS.format(new Date(), "YYYY-MM-DD HH:mm:ss"),
    });
    let currentHourPower = 0;
    
    currentHourPowerList.some((v) => {
      currentHourPower += v.lastPower - v.firstPower;
    });

    // console.log("currentHourPower", currentHourPower, currentHourPowerList, CS.maxZero(currentHourPower));
    this.setState({
      currentHourPower: CS.maxZero(currentHourPower),
    });

    this.getAccumulationPower(inverterSerialNos);
    this.getTodayPower(inverterSerialNos);
    this.getLastMonthPower(inverterSerialNos);
    this.getThisMonthPower(inverterSerialNos);
    this.getThisYearPower(inverterSerialNos);
    this.getTodayHourlyPower(
      MS.format(dailyYear + dailyMonth + dailyDay, "YYYY-MM-DD"),
      inverterSerialNos
    ); // 241101 기존 current date에서 state 값으로 변경 (data picker와 실제 데이터가 다른 문제 수정)
    this.getDailyPower(MS.format(year + month, "YYYY-MM"), inverterSerialNos); // 241101 기존 current date에서 state 값으로 변경 (data picker와 실제 데이터가 다른 문제 수정)
    this.getAccumulationPowerForChart(
      cumulativeToYear,
      activeTab,
      inverterSerialNos
    );
    // this.setState({
    //   refreshSeconds: 90,
    // });
  };

  getAccumulationPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      inverterSerialNos: inverterSerialNos,
    };
    //TODO API 확인
    let inverterData = [];
    if (param.inverterSerialNos.length !== 0) {
      inverterData = await PS.getLatestInverter(param);
    }
    // console.log("inverterData", inverterData);
    const days =
      MS.diff(info.operationStartDt, MS.current("YYYY-MM-DD"), "days") + 1;
    const accumulationPower = PS.getPowerByInverter(
      inverterData,
      "accumulationPower"
    );
    // console.log("accumulationPower", accumulationPower);
    this.setState({
      accumulationPower: accumulationPower,
      accumulationPowerTime:
        accumulationPower / info.installationCapacity,
      accumulationProfit: accumulationPower * info.unitPrice,
    });
  };

  getTodayPower = async (inverterSerialNos) => {
    const { info, currentHourPower } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ymd",
      date: MS.current("YYYY-MM-DD"),
      groupCols: ["ymd"],
    };
    const todayPower = (await PS.getTodayPower(param)) + currentHourPower;
    // console.log("todayPower", todayPower);
    // console.log("todayPowerTime", todayPower / info.installationCapacity);
    // console.log("todayProfit", todayPower * info.unitPrice);
    this.setState({
      todayPower: todayPower, // [금일발전량]
      todayPowerTime: todayPower / info.installationCapacity, // [금일발전시간]
      todayProfit: todayPower * info.unitPrice, // [금일발전수익]
    });
  };

  getLastMonthPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ym",
      date: MS.addAndFormat(new Date(), -1, "months", "YYYY-MM"),
      groupCols: ["ym"],
    };
    const lastDays = parseInt(MS.endOf(MS.add(new Date(), -1, "months"), "D"));
    const lastMonthPower = await PS.getTodayPower(param);
    this.setState({
      lastMonthPower: lastMonthPower,
      lastMonthPowerTime: lastMonthPower / info.installationCapacity / lastDays,
      lastMonthProfit: lastMonthPower * info.unitPrice,
    });
  };

  getThisMonthPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ym",
      date: MS.current("YYYY-MM"),
      groupCols: ["ym"],
    };
    const days = parseInt(MS.current("D"));
    const thisMonthPower =
      (await PS.getTodayPower(param)) + this.state.currentHourPower;
    this.setState({
      thisMonthPower: thisMonthPower,
      thisMonthPowerTime: thisMonthPower / info.installationCapacity / days,
      thisMonthProfit: thisMonthPower * info.unitPrice,
    });
  };

  getThisYearPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "y",
      date: MS.current("YYYY"),
      groupCols: ["y"],
    };
    const days =
      MS.diff(
        MS.startOf(new Date(), "year", "YYYY-MM-DD"),
        // new Date('2025-3-6'),
        MS.current("YYYY-MM-DD"),
        "days"
      ) + 1;
    const thisYearPower =
      (await PS.getTodayPower(param)) + this.state.currentHourPower;
    this.setState({
      thisYearPower: thisYearPower,
      thisYearPowerTime: thisYearPower / info.installationCapacity,
      thisYearProfit: thisYearPower * info.unitPrice,
    });
  };

  getTodayHourlyPower = async (date, inverterSerialNos) => {
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ymd",
      date: date,
      groupCols: ["hh"],
    };
    const hours = PS.getHourlyAxisx(date);
    const hourlyPower = await PS.getPowerList(param);

    if (date === MS.format(new Date(), "YYYY-MM-DD")) {
      hourlyPower.push({
        _id: MS.format(new Date(), "HH"),
        power: this.state.currentHourPower,
      });
    }
    
    const data = PS.settingChartData(hours, hourlyPower);
    const chartData = {};
    chartData.labels = hours;
    chartData.datasets = CS.formatDecimalInArray(data, 1);
    this.setState({
      chartTodayHourlyData: chartData,
    });
  };

  getDailyPower = async (ym, inverterSerialNos) => {
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ym",
      date: ym,
      groupCols: ["ymd"],
    };
    const dailyPowerList = await PS.getPowerList(param);
    const index = dailyPowerList.findIndex((e, index, array) => {
      return e._id === MS.current("YYYY-MM-DD");
    });
    if (index > -1) {
      dailyPowerList[index].power =
        dailyPowerList[index].power + this.state.currentHourPower;
    }
    const labels = PS.getDailyAxisx(ym);
    const data = PS.settingChartData(labels, dailyPowerList);
    const chartData = {};
    chartData.labels = labels;
    chartData.datasets = CS.formatDecimalInArray(data, 1);
    this.setState({
      chartData: chartData,
    });
  };

  getAccumulationPowerForChart = async (y, activeTab, inverterSerialNos) => {
    let chartDatas = [];
    for (let i = 0; i < 2; i++) {
      const param = {
        isPeriod: false,
        inverterSerialNos: inverterSerialNos,
        dateType: "y",
        date: y - i,
        groupCols: [activeTab],
      };
      const powerList = await PS.getPowerList(param);

      let index = -1;
      const chartLabels = [];
      let labels = [];
      if (activeTab == "ym") {
        labels = PS.getMonthlyAxisx(y - i);
        labels.some((v) => {
          chartLabels.push(Number(v.substring(5)));
        });
        index = powerList.findIndex((e, index, array) => {
          return e._id == MS.current("YYYY-MM");
        });
      } else if (activeTab == "quarter") {
        labels = ["1", "2", "3", "4"];
        labels.some((v) => {
          chartLabels.push(v);
        });
        index = powerList.findIndex((e, index, array) => {
          return e._id === MS.currentQuarter();
        });
      } else {
        labels = [(y - i).toString()];
        chartLabels.push((y - i).toString());
        index = powerList.findIndex((e, index, array) => {
          return e._id == MS.current("YYYY");
        });
      }

      if (index > -1) {
        powerList[index].power =
          Number(powerList[index].power) + this.state.currentHourPower;
      }

      const data = PS.settingChartData(labels, powerList);
      const chartData = {};
      chartData.labels = chartLabels;
      chartData.datasets = CS.formatDecimalInArray(data, 1);
      chartDatas.push(chartData);
    }

    if (activeTab == "y") {
      const yLabel = [];
      const yDatasets = [];
      chartDatas.some((v) => {
        yLabel.push(v.labels[0]);
        yDatasets.push(v.datasets[0]);
      });
      chartDatas.labels = yLabel;
      chartDatas.datasets = yDatasets;
    }

    this.setState({
      [activeTab + "ChartData"]: chartDatas,
    });
  };

  // async checkUserApprove() {
  //   let res = await axios.get(
  //     `/cst/api/constructor-plant/user-approve-check/${this.state.plantId}`
  //   );
  //   if (res.data.result) {
  //     MessageBox.confirm(
  //       "해당 발전소를 모니터링 하고자 하는 사용자가 존재합니다. 모니터링을 승인하시겠습니까?",
  //       "알림",
  //       {
  //         confirmButtonText: "OK",
  //         cancelButtonText: "Cancel",
  //         type: "info",
  //       }
  //     )
  //       .then(() => {
  //         axios
  //           .patch(
  //             `/cst/api/constructor-plant/approve-user-plant/${this.state.plantId}`
  //           )
  //           .then((res) => {
  //             Message({
  //               type: "success",
  //               message: "승인 되었습니다.",
  //             });
  //           });
  //       })
  //       .catch(() => {
  //         Message({
  //           type: "info",
  //           message: "취소 되었습니다.",
  //         });
  //       });
  //   }
  // }

  tabClickHandler = (id) => {
    this.setState({
      activeTab: id,
    });
    this.getAccumulationPowerForChart(
      this.state.cumulativeToYear,
      id,
      this.state.inverterSerialNos
    );
  };

  clickDateHandler = (gubun, step) => {
    if (gubun == "daily") {
      let { dailyYear, dailyMonth, dailyDay, inverterSerialNos } = this.state;
      const calcDay = MS.addAndFormat(
        dailyYear + dailyMonth + dailyDay,
        step === "+" ? 1 : -1,
        "days",
        "YYYY-MM-DD"
      );
      dailyYear = MS.format(calcDay, "YYYY");
      dailyMonth = MS.format(calcDay, "MM");
      dailyDay = MS.format(calcDay, "DD");
      this.setState({
        dailyYear: dailyYear,
        dailyMonth: dailyMonth,
        dailyDay: dailyDay,
        isDailyDisabled:
          dailyYear + dailyMonth + dailyDay < MS.format(new Date(), "YYYYMMDD")
            ? ""
            : "disabled",
      });
      this.getTodayHourlyPower(calcDay, inverterSerialNos);
    } else if (gubun == "cumulative") {
      let fromYear = this.state.cumulativeFromYear;
      let toYear = this.state.cumulativeToYear;
      fromYear = step == "+" ? fromYear + 1 : fromYear - 1;
      toYear = step == "+" ? toYear + 1 : toYear - 1;
      this.setState({
        cumulativeFromYear: fromYear,
        cumulativeToYear: toYear,
        isCumulativeDisabled:
          fromYear < MS.format(new Date(), "YYYY") ? "" : "disabled",
      });
      this.getAccumulationPowerForChart(
        toYear,
        this.state.activeTab,
        this.state.inverterSerialNos
      );
    } else {
      let year = this.state.year;
      let month = this.state.month;
      year = MS.addAndFormat(
        year + month + "01",
        step === "+" ? 1 : -1,
        "months",
        "YYYY"
      );
      month = MS.addAndFormat(
        year + month + "01",
        step === "+" ? 1 : -1,
        "months",
        "MM"
      );
      this.setState({
        year: year,
        month: month,
        isDisabled:
          year + month < MS.format(new Date(), "YYYYMM") ? "" : "disabled",
      });
      this.getDailyPower(year + "-" + month, this.state.inverterSerialNos);
    }
  };

  getChartDataSets(data) {
    let datasets = [];
    let dataset = {
      label: ["발전량"],
      backgroundColor: "#d6f71a",
      borderColor: "#c5e319",
      borderWidth: 2,
      data: data,
    };
    datasets.push(dataset);
    return datasets;
  }

  getMultiChartDataSets(data, cnt) {
    let datasets = [];
    for (let i = 0; i < cnt; i++) {
      let dataset = {
        label: Number(this.state.cumulativeToYear) - i,
        backgroundColor: i === 0 ? "#d6f71a" : "#eefc9a",
        borderColor: i === 0 ? "#c5e319" : "#e4fa64",
        borderWidth: 2,
        order: 2 - i,
        data: data[i].datasets,
      };
      datasets.push(dataset);
    }
    return datasets;
  }

  getLineChartDataSets(data) {
    let datasets = [];
    let dataset = {
      label: ["발전량(W)"],
      fill: false,
      lineTension: 0.3,
      backgroundColor: "rgba(214,247,26,0.4)",
      borderColor: "#d6f71a",
      borderCapStyle: "butt",
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      pointBorderColor: "rgba(75,192,192,1)",
      pointBackgroundColor: "#fff",
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "rgba(75,192,192,1)",
      pointHoverBorderColor: "rgba(220,220,220,1)",
      pointHoverBorderWidth: 2,
      pointRadius: 3,
      pointHitRadius: 10,
      data: data,
    };
    datasets.push(dataset);
    return datasets;
  }

  handleModal() {
    this.setState({
      isModalShow: true,
    });
  }
  handleCloseModal() {
    this.setState({
      isModalShow: false,
    });
  }

  formatSize(size) {
    if (size > 1000) {
      return size / 1000;
    }
    return size;
  }

  formatUnit(size) {
    if (size > 1000) {
      return "MWh";
    }
    return "kWh";
  }

  render() {
    const {
      // isModalShow,
      // refreshSeconds,
      // refreshStandard,
      info,
      cst,
      plantId,
      isDisabled,
      isDailyDisabled,
      // currentHour,
      year,
      month,
      dailyYear,
      dailyMonth,
      dailyDay,
      cumulativeFromYear,
      cumulativeToYear,
      activeTab,
      todayPower,
      lastMonthPower,
      thisMonthPower,
      thisYearPower,
      accumulationPower,
      todayPowerTime,
      lastMonthPowerTime,
      thisMonthPowerTime,
      thisYearPowerTime,
      accumulationPowerTime,
      todayProfit,
      lastMonthProfit,
      thisMonthProfit,
      thisYearProfit,
      accumulationProfit,
      chartData,
      ymChartData,
      quarterChartData,
      yChartData,
      chartTodayHourlyData,
      inverterSerialNos,
      // combinerSerialNos,
      isCumulativeDisabled,
      projectId
    } = this.state;
    const { t } = this.props;
    const { typeId, externalUrl } = info;
    const { typeId: plantTypeId } = this.props.location.state || {};
    // console.log("todayPower fianl", todayPower);
    return (
      <>
        <PageTitle title={t('key141')} location={t('key142')} />
        {
            plantTypeId === 2 ? (
              <iframe 
                title="external-monitoring"
                src={externalUrl}
                width="100%"
                height={"1000px"}
                style={{ border: "none", marginBottom: "30px", width: "1176px", margin: "0 auto", display: "block" }}
              />
            ) : (
              <>
                <InfoArea>
                  <InfoHead>
                    <h1>{info.name}</h1>
                    <ButtonArea>
                      <Link
                        to={{
                          // pathname: 
                            // plantId == 26
                            //   ? `/plant-status/issue/detail/${plantId}`
                            //   : `/plant-status/issue/detail-ov/${plantId}`,
                          pathname: ROUTES.PLANT_STATUS(projectId).ISSUE_DETAIL(plantId),
                          state: {
                            title: this.state.info.name,
                            projectAddr: this.state.projectAddr,
                            accumulationPower: accumulationPower,
                            capacity: info.installationCapacity,
                          }
                        }
                        }
                      >
                        {t('key143')}
                      </Link>
                      <a
                        onClick={() =>
                          window.open(
                            ROUTES.PLANT_STATUS(projectId).INVERTER(plantId),
                            "_blank"
                          )
                        }
                      >
                        {t('key144')}
                      </a>
                    </ButtonArea>
                  </InfoHead>
                  <InfoContent>
                    {/* <dl>
                      <dt>프로젝트 명</dt>
                      <dd>{this.state.projectName}</dd>
                    </dl>
                    <dl>
                      <dt>설치위치</dt>
                      <dd> {this.state.projectAddr} </dd>
                    </dl>
                    <dl>
                      <dt>설비용량</dt>
                      <dd>{info.installationCapacity} kW</dd>
                    </dl>
                    <dl className="total-unit">
                      <dt>총 누적 발전량</dt>
                      <dd>
                        <CountUp
                          start={0}
                          end={this.formatSize(accumulationPower)}
                          decimals={2}
                          duration={3.5}
                          separator=","
                        />
                        &nbsp;{this.formatUnit(accumulationPower)}
                      </dd>
                    </dl> */}
                    <div className="box">
                      <h2 className="tit">{t('key145')}</h2>
                      <InfoListBox>
                        <p>{`${t('key146')}: ${info.installationCapacity || "--"} kW`}</p>
                        <p>
                          {`${t('key147')}: `}
                          <CountUp
                            start={0}
                            end={this.formatSize(accumulationPower || 0)}
                            decimals={2}
                            duration={3.5}
                            separator=","
                          />
                          {` ${this.formatUnit(accumulationPower || 0)}`}
                        </p>
                      </InfoListBox>
                    </div>
                    <div className="box">
                      <h2 className="tit">{t('key148')}</h2>
                      <InfoListBox>
                        <p>{`${t('key149')}: ${cst.constructorName}`}</p>
                        <p>{`${t('key150')}: ${cst.contactNum}`}</p>
                      </InfoListBox>
                    </div>
                  </InfoContent>
                  <InfoList>
                    <ControlTitle>
                      <h2>{t('key151')}</h2>
                      <div>
                        {/* <AllPowerControll plantId={plantId} /> */}
                      </div>
                    </ControlTitle>
                    <ListWrapper>
                      <InfoListBox>
                        {/* <p>{`${t('key152')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key152')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(todayPower)}
                              decimals={2}
                              duration={0.5}
                              separator=","
                            />
                          </li>
                          <li>kWh</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        <AutoFitText max={15}>
                          {`${t('key153')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={this.formatSize(CS.maxZero(lastMonthPower))}
                              decimals={2}
                              duration={1}
                              separator=","
                            />
                          </li>
                          <li>{this.formatUnit(CS.maxZero(lastMonthPower))}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key154')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key154')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={this.formatSize(CS.maxZero(thisMonthPower))}
                              decimals={2}
                              duration={1.5}
                              separator=","
                            />
                          </li>
                          <li>{this.formatUnit(CS.maxZero(thisMonthPower))}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key155')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key155')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={this.formatSize(CS.maxZero(thisYearPower))}
                              decimals={2}
                              duration={2.5}
                              separator=","
                            />
                          </li>
                          <li>{this.formatUnit(CS.maxZero(thisYearPower))}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key156')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key156')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={this.formatSize(CS.maxZero(accumulationPower))}
                              decimals={2}
                              duration={3.5}
                              separator=","
                            />
                          </li>
                          <li>{this.formatUnit(CS.maxZero(accumulationPower))}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key157')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key157')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(todayPowerTime)}
                              decimals={2}
                              duration={0.5}
                              separator=","
                            />
                          </li>
                          <li>h</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key158')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key158')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(lastMonthPowerTime)}
                              decimals={2}
                              duration={1}
                              separator=","
                            />
                          </li>
                          <li>h</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key159')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key159')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(thisMonthPowerTime)}
                              decimals={2}
                              duration={1.5}
                              separator=","
                            />
                          </li>
                          <li>h</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key160')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key160')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(thisYearPowerTime)}
                              decimals={2}
                              duration={2.5}
                              separator=","
                            />
                          </li>
                          <li>h</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key161')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key161')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(accumulationPowerTime)}
                              decimals={2}
                              duration={3.5}
                              separator=","
                            />
                          </li>
                          <li>h</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key162')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key162')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(todayProfit)}
                              duration={0.5}
                              separator=","
                            />
                          </li>
                          <li>{`${t('key163')}`}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key164')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key164')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(lastMonthProfit)}
                              duration={1}
                              separator=","
                            />
                          </li>
                          <li>{`${t('key163')}`}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key165')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key165')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(thisMonthProfit)}
                              duration={1.5}
                              separator=","
                            />
                          </li>
                          <li>{`${t('key163')}`}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key166')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key166')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(thisYearProfit)}
                              duration={2.5}
                              separator=","
                            />
                          </li>
                          <li>{`${t('key163')}`}</li>
                        </ul>
                      </InfoListBox>
                      <InfoListBox>
                        {/* <p>{`${t('key167')}`}</p> */}
                        <AutoFitText max={15}>
                          {`${t('key167')}`}
                        </AutoFitText>
                        <ul>
                          <li>
                            <CountUp
                              start={0}
                              end={CS.maxZero(accumulationProfit)}
                              duration={3.5}
                              separator=","
                            />
                          </li>
                          <li>{t('key163')}</li>
                        </ul>
                      </InfoListBox>
                    </ListWrapper>
                  </InfoList>
                  <CurrentTime>
                    <ul className="head">
                      <li>{`${t('key168')}`}</li>
                      <li>
                        <Clock
                          format={"YYYY.MM.DD HH:mm:ss"}
                          ticking={true}
                          timezone={"Asia/Seoul"}
                        />
                      </li>
                    </ul>
                    {/* <ProgressBar
                      // animated
                      // variant="custom-progressbar-color-red"
                      variant="custom-progressbar"
                      label={`${refreshSeconds}초`}
                      now={refreshSeconds * refreshStandard}
                    /> */}
                    {
                      <CountDownTimer 
                        onRefresh={this.getData}
                        refreshSeconds={90}
                        isInfinite={true}
                      />
                    }
                  </CurrentTime>
                </InfoArea>
                {/* 2024.10.31 */}
                <section className="power-plant-graph">
                  <div className="container">
                    <div className="f-stack">
                      <h3 className="content-tit1">{t('key170')}</h3>
                      <div className="pr-25">
                        <div className="chart-caption">
                          <i className="circle-bg"></i>
                          <strong className="mx-10">{t('key171')}</strong>
                          <span className="tool-tip right">
                            <span className="text w350">
                              {t('key172')}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="card graph">
                      <div className="calendar">
                        <div className="control">
                          <button
                            type="button"
                            className="prev"
                            onClick={() => this.clickDateHandler("daily", "-")}
                          ></button>
                          <strong className="date"> 
                            <span className="year">{Number(dailyYear)}</span>
                            <span className="month">{Number(dailyMonth)}</span>&nbsp;
                            <span className="day">{Number(dailyDay)}</span>
                          </strong>
                          <button
                            type="button"
                            className="next"
                            onClick={() => this.clickDateHandler("daily", "+")}
                            disabled={isDailyDisabled}
                          ></button>
                        </div>
                      </div>
                      <div className="chart">
                        {!CS.checkIsEmptyObject(chartTodayHourlyData) ? (
                          <LineChart
                            text="발전량 그래프(단위, kWh)"
                            labels={chartTodayHourlyData.labels}
                            datasets={this.getLineChartDataSets(
                              chartTodayHourlyData.datasets
                            )}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    <div className="f-stack mt-30">
                      <h3 className="content-tit1">{t('key177')}</h3>
                      <div className="pr-25">
                        <div className="chart-caption">
                          <i className="circle-bg"></i>
                          <strong className="mx-10">{t('key178')}</strong>
                          <span className="tool-tip right">
                            <span className="text w350">
                              {t('key179')}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="card graph">
                      <div className="calendar">
                        <div className="control">
                          <button
                            type="button"
                            className="prev"
                            onClick={() => this.clickDateHandler("", "-")}
                          >
                            <strong>이전달</strong>
                          </button>
                          <strong className="date">
                            <span className="year">{year}</span>
                            <span className="month">{month}</span>
                          </strong>
                          <button
                            type="button"
                            className="next"
                            onClick={() => this.clickDateHandler("", "+")}
                            disabled={isDisabled}
                          >
                            <strong>다음달</strong>
                          </button>
                        </div>
                      </div>
                      <div className="chart" id="powerPlantGraph">
                        {!CS.checkIsEmptyObject(chartData) ? (
                          <BarChart
                            text="발전량 그래프(단위, kWh)"
                            labels={chartData.labels}
                            datasets={this.getChartDataSets(chartData.datasets)}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    <div className="f-stack mt-30">
                      {/* 누적 발전량 그래프(단위, kWh) */}
                      <h3 className="content-tit1">{t('key533')}</h3>
                      <div className="pr-25">
                        <div className="calendar sm gray">
                          <div className="control">
                            <button
                              type="button"
                              className="prev"
                              onClick={() => this.clickDateHandler("cumulative", "-")}
                            >
                              <strong>이전달</strong>
                            </button>
                            <strong className="date">
                              <span className="year">{cumulativeFromYear}</span>
                              <span className="year">{cumulativeToYear}</span>
                            </strong>
                            <button
                              type="button"
                              className="next"
                              onClick={() => this.clickDateHandler("cumulative", "+")}
                              disabled={isCumulativeDisabled}
                            >
                              <strong>다음달</strong>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card cumulative-power">
                      <div id="chartTabPanel" className="tabs-wrapper">
                        <nav className="tab-menu">
                          <a
                            onClick={() => this.tabClickHandler("ym")}
                            className={activeTab == "ym" ? "active" : ""}
                          >
                            {/* 월간 */}
                            {t('key534')}
                          </a>
                          <a
                            onClick={() => this.tabClickHandler("quarter")}
                            className={activeTab == "quarter" ? "active" : ""}
                          >
                            {/* 분기 */}
                            {t('key535')}
                          </a>
                          <a
                            onClick={() => this.tabClickHandler("y")}
                            className={activeTab == "y" ? "active" : ""}
                          >
                            {/* 연간 */}
                            {t('key536')}
                          </a>
                        </nav>
                        <div className="tab-contents">
                          <div
                            id="tabs-1"
                            className="tab-panel"
                            style={
                              activeTab == "ym"
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            {!CS.checkIsEmptyObject(ymChartData) ? (
                              <BarChart
                                id="powerPlantMonth"
                                text="누적 발전량(월간)"
                                labels={ymChartData[0].labels}
                                datasets={this.getMultiChartDataSets(ymChartData, 2)}
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                          <div
                            id="tabs-2"
                            className="tab-panel"
                            style={
                              activeTab == "quarter"
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            {!CS.checkIsEmptyObject(quarterChartData) ? (
                              <BarChart
                                id="powerPlantQuarter"
                                text="누적 발전량(분기별)"
                                labels={quarterChartData[0].labels}
                                datasets={this.getMultiChartDataSets(
                                  quarterChartData,
                                  2
                                )}
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                          <div
                            id="tabs-3"
                            className="tab-panel"
                            style={
                              activeTab == "y"
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            {!CS.checkIsEmptyObject(yChartData) ? (
                              <BarChart
                                id="powerPlantYear"
                                text="누적 발전량(연간)"
                                labels={yChartData.labels}
                                datasets={this.getChartDataSets(yChartData.datasets)}
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                {/* <hr className="style1"></hr> */}
                <section>
                  <div className="container">
                    <ItemContainer gridFr="1fr">
                      <h3 className="content-tit1">
                        <i className="material-icons file">folder</i> {t('key180')}
                      </h3>
                      <div className="f-stack spacing25">
                        <button
                          type="button"
                          className="btn white wp100"
                          onClick={() => CS.fileDown(info.oneLineDiagramFileId)}
                        >
                          {t('key181')}
                        </button>
                        <button
                          type="button"
                          className="btn white wp100"
                          onClick={() => CS.fileDown(info.floorPlanFileId)}
                        >
                          {t('key182')}
                        </button>
                        <button
                          type="button"
                          className="btn white wp100"
                          onClick={() => {
                            
                            CS.fileDown(info.serialNoFileId);
                          }}
                        >
                          {t('key183')}
                        </button>
                      </div>
                    </ItemContainer>
                    <ItemContainer gridFr="1fr">
                      <SolarBasicInfo 
                        operationStartDt={info.operationStartDt}
                        diff={info.diff}
                        ownerName={info.ownerName}
                      />
                    </ItemContainer>
                    {/* <h3 className="content-tit1">기본 정보</h3>
                    <div className="card2">
                      <div className="f-stack form-view">
                        <div className="wp50">
                          <span className="tit">운전 개시일</span>
                          <strong>{info.operationStartDt}</strong>
                          <small className="size13 ml-10">{info.diff}</small>
                        </div>
                        <div className="wp50">
                          <span className="tit">사업주 명</span>
                          <strong>{info.ownerName}</strong>
                        </div>
                      </div>
                    </div> */}
                    <Divider />
                    <ItemContainer gridFr="1fr">
                      <SolarInfo 
                        installationCnt={info.installationCnt}
                        installationCapacity={info.installationCapacity}
                        moduleCnt={inverterSerialNos.length}
                      />
                    </ItemContainer>
                    {/* <h3 className="content-tit1">태양광 설비 세부 정보</h3>
                    <div className="card2">
                      <table className="style1">
                        <colgroup>
                          <col style={{ width: "16%" }} />
                          <col />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "14%" }} />
                          <col style={{ width: "14%" }} />
                          <col style={{ width: "18%" }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th className="left">태양광 모듈 &gt;</th>
                            <td>{info.moduleCorpName}</td>
                            <td>{info.moduleModelName}</td>
                            <td>{info.installationCnt} 장</td>
                            <td>{info.installationCapacity} W</td>
                            <td>{info.moduleCorpPhone}</td>
                          </tr>
                          <tr>
                            <th className="left">인버터 &gt;</th>
                            <td>{info.inverterCorpName}</td>
                            <td>{info.inverterModelName}</td>
                            <td>{inverterSerialNos.length}대</td>
                            <td></td>
                            <td>{info.inverterCorpPhone}</td>
                          </tr>
                          <tr>
                            <th className="left">구조물 &gt;</th>
                            <td>{info.structureName}</td>
                            <td>용용아연 철</td>
                            <td></td>
                            <td></td>
                            <td>{info.structureBizTelNum}</td>
                          </tr>
                          <tr>
                            <th className="left">전기 공사 &gt;</th>
                            <td>{info.electricWorkBizName}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{info.electricWorkBizTelNum}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div> */}
                  </div>
                </section>
              </>
            )
          }
      </>
    );
  }
}

const ButtonArea = styled.div`
  a {
    display: inline-block;
    background-color: var(--primary-500);
    border: 1px solid var(--primary-500);
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #211b41;
    padding: 12px 40px;
    text-align: center;
    text-decoration: none;
    &:last-child {
      margin-left: 20px;
    }
  }
`;

const ControlTitle = styled.div`
  display: flex;
  justify-content: space-between;
  & > div {
    display: flex;
    h2 {
      margin-right: 20px;
      font-size: 20px;
      font-weight: 900;
      letter-spacing: 2px;
    }
  }
`;

const ItemContainer = styled.div`
  display: grid;
  ${({ gridFr }) => gridFr && `grid-template-columns: ${gridFr};`}
  width: 100%;
  padding: 30px 0;
  gap: 24px;
`;

export default withTranslation()(SolarPanelDetail);
